const productsTemp = [
    {
        id: 0,
        title: "Red Tee",
        description:
            "Red Tee. Stay STYLIN' during the winter while keeping warm. Sourced from our domestic factories to the highest quality standards.",
        price: 29.95,
        image: "product-1.jpg",
        featured: false,
    },
    {
        id: 1,
        title: "Black Shoes",
        description: "Black Shoes. Sourced from our domestic factories to the highest quality standards.",
        price: 99.95,
        image: "product-2.jpg",
        featured: false,
    },
    {
        id: 2,
        title: "Sweat Pants",
        description:
            "Dark gray sweat pants, made of 100% cotton. Stay STYLIN' during the winter while keeping warm. Sourced from our domestic factories to the highest quality standards.",
        price: 39.95,
        image: "product-3.jpg",
        featured: false,
    },
    {
        id: 3,
        title: "Blue Tee",
        description:
            "Blue Tee. Stay STYLIN' during the winter while keeping warm. Sourced from our domestic factories to the highest quality standards.",
        price: 29.95,
        image: "product-4.jpg",
        featured: true,
    },
    {
        id: 4,
        title: "Grey Shoes",
        description: "Grey Shoes. Sourced from our domestic factories to the highest quality standards.",
        price: 109.95,
        image: "product-5.jpg",
        featured: false,
    },
    {
        id: 5,
        title: "Black Tee",
        description:
            "Black Tee. Stay STYLIN' during the winter while keeping warm. Sourced from our domestic factories to the highest quality standards.",
        price: 29.95,
        image: "product-6.jpg",
        featured: true,
    },
    {
        id: 6,
        title: "Socks",
        description: "Socks. Sourced from our domestic factories to the highest quality standards.",
        price: 19.95,
        image: "product-7.jpg",
        featured: false,
    },
    {
        id: 7,
        title: "Black Watch",
        description: "Black Watch. Sourced from our domestic factories to the highest quality standards.",
        price: 119.95,
        image: "product-8.jpg",
        featured: true,
    },
];

const reviews = [
    {
        id: 0,
        name: "Mable Stewart",
        image: "user-1.png",
        text: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio nesciunt iure ea laudantium assumenda consequatur quibusdam pariatur provident delectus sequi.`,
    },
    {
        id: 1,
        name: "Deshawn Richards",
        image: "user-2.png",
        text: `Lorem ipsum, dolor sit amet consectetur adipisicing elit. Perferendis labore minima velit? Adipisci, nesciunt!`,
    },
    {
        id: 2,
        name: "Tracy McGregor",
        image: "user-3.png",
        text: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Itaque iusto quo doloribus omnis tenetur suscipit maiores eaque.`,
    },
];

const brands = [
    {
        id: 0,
        src: "brands/logo-oppo.png",
    },
    {
        id: 1,
        src: "brands/logo-coca-cola.png",
    },
    {
        id: 2,
        src: "brands/logo-paypal.png",
    },
    {
        id: 3,
        src: "brands/logo-philips.png",
    },
    {
        id: 4,
        src: "brands/logo-godrej.png",
    },
];

const exclusiveProd = {
    title: "Smart Band 9000",
    description:
        "The Smart Band 9000 can... wait for it... TELL THE TIME! Get this bleeding edge piece of technology now. Be the envy of your friends",
    price: 32.95,
    image: "exclusive.png",
};

export { productsTemp, reviews, brands, exclusiveProd };
